"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducerManager = createReducerManager;
var _redux = require("redux");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Defines a reducer manager which can be used to dynamically add and remove reducers from the store.
 * great for code splitting/lazy loading and allow games to add their own reducers/state.
 *
 * @param initialReducers
 * @returns
 */
function createReducerManager(initialReducers) {
  // Create an object which maps keys to reducers
  var reducers = _objectSpread({}, initialReducers);

  // Create the initial combinedReducer
  var combinedReducer = (0, _redux.combineReducers)(reducers);

  // An array which is used to delete state keys when reducers are removed
  var keysToRemove = [];
  return {
    getReducerMap: function getReducerMap() {
      return reducers;
    },
    // The root reducer function exposed by this object
    // This will be passed to the store
    reduce: function reduce(state, action) {
      // If any reducers have been removed, clean up their state first
      if (keysToRemove.length > 0) {
        state = _objectSpread({}, state);
        for (var _i = 0, _keysToRemove = keysToRemove; _i < _keysToRemove.length; _i++) {
          var key = _keysToRemove[_i];
          delete state[key];
        }
        keysToRemove = [];
      }

      // Delegate to the combined reducer
      //@ts-ignore
      return combinedReducer(state, action);
    },
    // Adds a new reducer with the specified key
    add: function add(key, reducer) {
      if (!key || reducers[key]) {
        return;
      }

      // Add the reducer to the reducer mapping
      reducers[key] = reducer;

      // Generate a new combined reducer
      combinedReducer = (0, _redux.combineReducers)(reducers);
    },
    // Removes a reducer with the specified key
    remove: function remove(key) {
      if (!key || !reducers[key]) {
        return;
      }

      // Remove it from the reducer mapping
      delete reducers[key];

      // Add the key to the list of keys to clean up
      keysToRemove.push(key);

      // Generate a new combined reducer
      combinedReducer = (0, _redux.combineReducers)(reducers);
    }
  };
}
//# sourceMappingURL=createReducerManager.js.map